import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CommonComponent } from '../../common/common.component';
import { LoadingComponent } from '../loading/loading.component';

@Component({
  selector: 'app-search-bar-ateco',
  templateUrl: './search-bar-ateco.component.html',
  styleUrls: ['./search-bar-ateco.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, LoadingComponent, RouterLink],
})
export class SearchBarAtecoComponent extends CommonComponent implements OnInit {
  private searchTimer: any;
  public disableBtn = true;
  public searchValue = '';


  @Input() s = '';
  @Input() forbiddenError = false;
  @Output() openLoginPopupEvt = new EventEmitter();

  constructor(

    public authenticationService: AuthenticationService,
    public main: AppComponent,
  ) {
    super(authenticationService);
  }

  ngOnInit(): void {
    this.searchValue = this.s;
  }

  oneKeyUpInput(evt: KeyboardEvent, s: string): any {
    clearTimeout(this.searchTimer);
    if (s.length > 2) {
      this.disableBtn = false;
      this.searchValue = s;
    } else {
      this.disableBtn = true;
    }
  }

  async handleAtecoSearch(): Promise<void> {
    if (this.isLogged) {
      await this.main.applyAtecoSearch(this.searchValue);
    } else {
      this.openLoginPopupEvt.emit();
    }
  }
}
